import { Component } from '@theme/component';

class FreedomProductSpotlight extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('change', this.#handleVariantChange);
    this.#syncInitialVariant();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#syncInitialVariant();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('change', this.#handleVariantChange);
  }

  #handleVariantChange = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.dataset.spotlightVariant !== 'true') return;

    this.#applyVariant(target);
  };

  #syncInitialVariant() {
    const optionInputs = this.querySelectorAll('input[data-spotlight-variant="true"]');
    const checkedInput = Array.from(optionInputs).find((input) => input.checked) || optionInputs[0];

    if (checkedInput instanceof HTMLInputElement) {
      this.#applyVariant(checkedInput);
    }
  }

  /**
   * @param {HTMLInputElement} input
   */
  #applyVariant(input) {
    const productForm = this.querySelector('product-form-component');
    const addToCartComponent = this.querySelector('add-to-cart-component');
    const price = this.querySelector('[ref="spotlightPrice"]');
    const comparePrice = this.querySelector('[ref="spotlightComparePrice"]');
    const comparePriceWrap = this.querySelector('[ref="spotlightComparePriceWrap"]');
    const addToCartLabel = this.querySelector('[ref="spotlightAddToCartLabel"]');

    const variantId = input.dataset.variantId || '';
    const variantAvailable = input.dataset.variantAvailable === 'true';
    const variantPrice = input.dataset.price || '';
    const variantComparePrice = input.dataset.comparePrice || '';
    const variantMedia = input.dataset.variantMedia || '';

    if (productForm?.refs?.variantId instanceof HTMLInputElement) {
      productForm.refs.variantId.value = variantId;
    }

    if (price instanceof HTMLElement && variantPrice) {
      price.textContent = variantPrice;
    }

    if (comparePrice instanceof HTMLElement && comparePriceWrap instanceof HTMLElement) {
      if (variantComparePrice) {
        comparePrice.textContent = variantComparePrice;
        comparePriceWrap.hidden = false;
      } else {
        comparePrice.textContent = '';
        comparePriceWrap.hidden = true;
      }
    }

    if (addToCartLabel instanceof HTMLElement) {
      addToCartLabel.textContent = variantAvailable ? this.dataset.addLabel || 'ADD TO CART' : this.dataset.soldOutLabel || 'SOLD OUT';
    }

    if (addToCartComponent?.refs?.addToCartButton instanceof HTMLButtonElement) {
      addToCartComponent.refs.addToCartButton.disabled = !variantAvailable;
    }

    if (addToCartComponent instanceof HTMLElement && variantMedia) {
      addToCartComponent.dataset.productVariantMedia = variantMedia;
    }
  }
}

if (!customElements.get('freedom-product-spotlight-component')) {
  customElements.define('freedom-product-spotlight-component', FreedomProductSpotlight);
}
